import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { Alert } from '@app/core/domain';

export interface AlertStateModel extends EntityState<Alert> {}

@Injectable()
@StoreConfig({ name: 'alerts' })
export class AlertStore extends EntityStore<AlertStateModel, Alert> {

  constructor() {
    super();
  }
}
